/* Copyright (c) 2023 Xperi. All Rights Reserved. */

import React, { FunctionComponent, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { RootState } from '../../../store/root.reducers';
import { Locale } from '../../../core/locale/Locale';
import { LocaleKeys } from '../../../core/locale/LocaleKeys';
import Menu from '../Menu/Menu';
import { DeviceModel } from '../../../core/device/DeviceModel';
import { setDefaultMenuLangaugeState } from '../../../store/settings/menulanguage/menulanguage.reducers';
import { MenuLanguageProps } from './MenuLanguagesProps';
import { SettingsMenuTypes } from '../SettingsMenuTypes';
import { Settings } from '../../../core/device/Settings';

import './MenuLanguages.scss';

const MenuLanguages: FunctionComponent<MenuLanguageProps> = (props): JSX.Element => {
    const { focusedItemIndex, isFocused } = useSelector((state: RootState) => state.settings);
    const { languages } = props;
    const { verticalPosition } = useSelector((state: RootState) => state.menulanguage);
    const [tickIndex, setTickIndex] = useState(0);
    const dispatch = useDispatch();
    const settingsService = new Settings();
    const isVideoWindowEnabled = settingsService.isVideoWindowEnabled();

    const languageMap = {
        en: Locale.getString(LocaleKeys.SETTINGS_ENGLISH),
        es: Locale.getString(LocaleKeys.SETTINGS_SPANISH),
    };

    useEffect(() => {
        dispatch(setDefaultMenuLangaugeState(languages.length, 0));
        const language = DeviceModel.getTVProperties().getLang();
        setTickIndex(languages.indexOf(languageMap[language]));
    }, []);

    return (
        <div className="menu-language-container">
            <div
                className={`${
                    !isVideoWindowEnabled
                        ? 'select-the-text'
                        : 'select-the-text settings-video-window'
                }`}
            >
                {Locale.getString(LocaleKeys.SETTINGS_MENU_LANGUAGE_PAGE_DESCRIPTION)}
            </div>
            <div className="language-list">
                <Menu
                    items={languages}
                    isFocused={isFocused}
                    selectedIndex={verticalPosition}
                    tick={tickIndex}
                    name={SettingsMenuTypes.MENU}
                    focusedIndex={focusedItemIndex}
                />
            </div>
        </div>
    );
};

MenuLanguages.propTypes = {
    languages: PropTypes.any,
};

export default MenuLanguages;
